import React from 'react';
import FormEditGeneral from './components/form-edit-general';

const RoleEdit = props => <FormEditGeneral {...props} />;

export default RoleEdit;
